export function getPercentageValue(value: number, hundred: number): number {
  return hundred > 0 ? value / hundred : 0;
}
